import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AccessHero from './components/AccessHero';
import AccessInfo from './components/AccessInfo';
import AccessMap from './components/AccessMap';

const AccessPage = () => {
  usePageMeta({
    title: 'アクセス | 株式会社MSK',
    ogTitle: 'アクセス | 株式会社MSK',
    description: '株式会社MSKへのアクセス情報をご案内いたします。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <AccessHero />
        <AccessInfo />
        <AccessMap />
      </main>
      <Footer />
    </div>
  );
};

export default AccessPage;